import React, { useEffect, useState, useRef } from 'react';
import { cn } from '../../lib/utils';
import { useMotionValue, motion, useMotionTemplate } from 'framer-motion';
import { Squares } from './SquaresBackground';
export const HeroHighlight = ({
  children,
  className,
  containerClassName
}: {
  children: React.ReactNode;
  className?: string;
  containerClassName?: string;
}) => {
  let mouseX = useMotionValue(0);
  let mouseY = useMotionValue(0);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  useEffect(() => {
    if (!isMobile) return;
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const viewportHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const videoSectionOffset = viewportHeight * 0.25;
      const adjustedScrollY = Math.max(0, scrollY - videoSectionOffset);
      const adjustedDocumentHeight = documentHeight - videoSectionOffset;
      const scrollPercentY = Math.min(adjustedScrollY / (adjustedDocumentHeight - viewportHeight), 1);
      mouseX.set(window.innerWidth / 2);
      mouseY.set(videoSectionOffset + scrollPercentY * (documentHeight - viewportHeight));
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isMobile, mouseX, mouseY]);
  return <div className={cn('relative min-h-screen flex items-start bg-black justify-center w-full group', containerClassName)} data-id="element-82">
      {/* Full-screen background pattern */}
      <div className="absolute inset-0 pointer-events-none" data-id="element-83">
        <Squares direction="diagonal" speed={0.3} squareSize={50} borderColor="#444" hoverFillColor="#333" className="opacity-70" data-id="element-84" />
      </div>
      {/* Main content */}
      <div className={cn('relative z-20 w-full', className)} data-id="element-85">{children}</div>
    </div>;
};
export const Highlight = ({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <motion.span initial={{
    backgroundSize: '0% 100%'
  }} whileInView={{
    backgroundSize: '100% 100%'
  }} viewport={{
    once: true
  }} transition={{
    duration: 1.5,
    ease: 'linear',
    delay: 0.2
  }} style={{
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'left center',
    display: 'inline'
  }} className={cn('relative inline-block pb-1 px-1 rounded-lg bg-gradient-to-r from-[#00AEEF]/80 to-[#00AEEF]/80', className)} data-id="element-86">
      {children}
    </motion.span>;
};